import isEmpty from 'lodash/isEmpty';
import { GetStaticProps, NextPage } from 'next';
import React from 'react';

import HelpCategoriesTemplate from '@/components/templates/HelpCategoriesTemplate';
import { HELP_SEARCH_URL } from '@/constants/urls';
import {
  fetchArticles,
  fetchSidebarLinks,
  IArticleTagsAndCategories,
  IPageCategory,
} from '@/services/getHelpPageData';

interface SidebarLinks {
  helpCategories: IPageCategory[];
  popArticles: IPageCategory[];
}
interface IProps {
  articleList: IArticleTagsAndCategories[];
  sidebarLinks: SidebarLinks;
}

const SearchHome: NextPage<IProps> = ({ articleList, sidebarLinks }) => {
  const pageTitle = 'Help And Support';

  return (
    <HelpCategoriesTemplate
      articleCategories={articleList}
      helpCategories={sidebarLinks.helpCategories}
      articles={sidebarLinks.popArticles}
      title={pageTitle}
      slug="search"
    />
  );
};

export const getStaticProps: GetStaticProps = async () => {
  try {
    const path = HELP_SEARCH_URL;
    const { articleList, fetchArticlesError } = await fetchArticles(path);
    const { sidebarLinks, fetchSidebarLinksError } = await fetchSidebarLinks();

    //handle no result or errors
    if (fetchArticlesError || fetchSidebarLinksError) {
      return {
        notFound: true,
        revalidate: 86400,
      };
    } else if (isEmpty(articleList)) {
      return {
        props: {
          serverRendering: true,
          articleResults: [],
          sidebarLinks,
        },
        revalidate: 86400,
      };
    }

    return {
      props: {
        serverRendering: true,
        articleList,
        sidebarLinks,
      },
      revalidate: 86400,
    };
  } catch {
    //redirect to 404 page
    return {
      notFound: true,
      revalidate: 86400,
    };
  }
};

export default SearchHome;
